// eslint-disable-next-line import/prefer-default-export
export const ConditionOptions = {
  issueSeverity: 'issueSeverity',
  issueName: 'issueName',
};

export const OperatorOptions = {
  is: 'is',
  isNot: 'isNot',
  includes: 'includes',
  notIncludes: 'notIncludes',
};
